import { apiClient } from '@/lib/api/apiClient';
import { endpoints } from '@/lib/api/apiEndpoints';

export interface UserDto {
  id: string;
  userId: string; // email
  displayName: string;
  role: string;
  isBanned: boolean;
  bannedUntil?: string;
  banReason?: string;
  createdAt: string;
  lastPlayedAt?: string;
}

export interface PagedResult<T> {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
}

export const userService = {
  async getAllUsers(params?: {
    searchTerm?: string;
    role?: string;
    isBanned?: boolean;
    pageNumber?: number;
    pageSize?: number;
  }): Promise<PagedResult<UserDto>> {
    const response = await apiClient.get(endpoints.admin.users(), { params });
    return response.data.data;
  },

  async banUser(id: string, reason: string, until?: string): Promise<void> {
    await apiClient.post(`${endpoints.admin.users()}/${id}/ban`, { reason, until });
  },

  async unbanUser(id: string): Promise<void> {
    await apiClient.post(`${endpoints.admin.users()}/${id}/unban`);
  },

  async updateUserRole(id: string, role: string): Promise<void> {
    await apiClient.patch(`${endpoints.admin.users()}/${id}/role`, { role });
  },
};
